import $ from 'jquery';
import { TweenLite } from 'gsap';
import * as ViewportServices from '../services/Viewport';
import { loadComponents } from './componentUtils';

export default class xhrController {

    constructor() {
        this.$doc = $(document);
        this.$window = $(window);
        this.$body = $('body');
        this.$container = $('#xhr');
        this.$footer = $('#footer');
        this.$stripe = $('#stripe');
        this.previousUrl;
        this.getUrl();
        this.current = this.previousUrl;
        this.next = '';
        this.cache = {};
        this.LINK_SELECTOR = 'a[href^="/"]:not([data-no-transition]):not([href^="/data"]):not([data-trigger]):not([data-img-size]):not(.ajax):not([data-component="LoadMore"]), a[xlink\\:href]';
        this.xhrForms = $('form:not([data-no-transition])');
        this.prepare();
    }

    prepare() {
        var self = this;
        if (!('pushState' in window.history) || this.$body.data('page-transition') === false) {
            return;
        }
        if (this.$body.hasClass('cms')) {
            return;
        }
        this.$doc.on('click', this.LINK_SELECTOR, event => {
            event.preventDefault();
            var path = this.getUrlPath(event.currentTarget.href);
            if (path == this.current) {
                ViewportServices.scrollTo();
            } else {
                this.loadPage(path, false);
            }
        });

        this.xhrForms.on('submit', function (event) {
            event.preventDefault();
            self.current = $(this).attr('action');
            var finalPage = null;

            // handle classes and events before unload
            self.$doc.trigger('load:beforeLeave');
            self.animateOut();

            self.$body.addClass('show-loading');
            $.ajax({
                url: $(this).attr('action'),
                type: $(this).attr('method'),
                data: $(this).serialize(),
                success: (response, status, xhr) => {
                    // get json data
                    var ct = xhr.getResponseHeader("content-type") || "";
                        if (ct.indexOf('html') > -1) {
                            var page = this.getDataFromHtml(response);
                        }
                        if (ct.indexOf('json') > -1) {
                            var page = response;
                            if (response.redirect !== null) {
                                self.loadPage(response.redirect, event);
                                return;
                            }
                        }

                        // render page
                        finalPage = page;
                        self.renderPage(finalPage, event);
                    }
            });
        });

        window.onpopstate = (event) => {
            var url = (event.state ? event.state.url : window.location.pathname);
            var path = this.getUrlPath(url);
            self.loadPage(path, event);
        };

        var page = this.getDataFromHtml(this.$doc.find('html').html());
        page.url = this.previousUrl;
        //this.cacheUrl(page);
        this.gtmEvent(page.url, page.title);
    }

    loadPage(url, popstate) {
        this.current = url;
        //var xhrUrl = url + '?xhr';
        var xhrUrl = url;
        var finalPage = null;

        // handle classes and events before unload
        this.$doc.trigger('load:beforeLeave');
        this.animateOut();

        if (url in this.cache) {
            this.$body.addClass('show-preloaded');
            // render page
            finalPage = this.cache[url];
            setTimeout(() => {
                this.renderPage(finalPage, popstate);
            }, 600);
        } else {
            this.$body.addClass('show-loading');
            $.ajax({
                url: xhrUrl,
                type: 'POST',
                success: (response, status, xhr) => {
                    // get json data
                    var ct = xhr.getResponseHeader("content-type") || "";
                    if (ct.indexOf('html') > -1) {
                        var page = this.getDataFromHtml(response);
                    }
                    if (ct.indexOf('json') > -1) {
                        var page = response;
                    }
                    page.url = url;

                    // render page
                    finalPage = page;
                    //this.cacheUrl(page);
                    this.renderPage(finalPage, false);
                }
            });
        }
    }

    renderPage (page, popstate) {
        this.animateIn();
        this.$container.html(page.content);
        loadComponents(this.$container);
        this.gtmEvent(page.url, page.title);
        // handle classes after render
        this.$body.removeClass (function (index, className) {
            return (className.match (/(^|\s)page-\S+/g) || []).join(' ');
        });
        this.$body.removeClass (function (index, className) {
            return (className.match (/(^|\s)color-\S+/g) || []).join(' ');
        });

        //this.$body.addClass(page.pageClass);
        this.$body.addClass(page.pageClass);
        this.$body.removeClass('unload').removeClass('unload-all');
        this.$doc.trigger('load:afterRender');

        // set title
        document.title = page.title;

        // push popstate
        if (!popstate) {
            this.createState(page.url);
        }
        this.getUrl();
    }

    createState(url) {
        window.history.pushState(
            {
                url: url || window.location.href.split(window.location.hostname)[1],
                random: Math.random()
            },
            $('html').find('title').text(),
            url || window.location.href.split(window.location.hostname)[1]
        );
    }

    cacheUrl (page) {
        if (page.url in this.cache == false) {
            this.cache[page.url] = page;
        }
        console.groupCollapsed('Cache');
        for (var key in this.cache){
            console.log(this.cache[key]);
        }
        console.groupEnd();
    }

    getDataFromHtml (html) {
        var content = html.replace('<body', '<div id="body"').replace('</body>', '</div>');
        var $buffer = $('<div/>');
        $buffer.html(content);

        var json = {
            content:  $buffer.find('#xhr').html(),
            title: $buffer.find('title').text(),
            pageClass:  $buffer.find('#body').attr('class')
        }
        return json;
    }

    getUrlPath (href) {
        var l = document.createElement("a");
        l.href = href;
        var path = l.pathname;
        if (path[0] != '/') {
            path = '/' + path;
        }
        return path;
    }

    getUrl() {
        this.previousUrl = window.location.pathname + window.location.search;
    }

    animateOut () {
        // android fix
        setTimeout(() => {
            $('html').addClass("androidFix");
            this.$body.scrollTop(0);
            window.scrollTop = 0;
            $("html").scrollTop(0);
        }, 600);
        TweenLite.to( this.$container,.6,  {
            opacity: '0',
            top: '100px',
            //delay:.3,
            ease: Back.easeOut
        });
        TweenLite.to( this.$footer,.6,  {
            opacity: '0',
            transform: 'translate3d(0, 100px, 0)',
            //delay:.3,
            ease: Back.easeOut
        });

        TweenLite.to(this.$stripe, 3, {
            transform: 'skewY(4.5deg)',
            //ease: Power2.easeOut,
            delay: 0
        });
        TweenLite.to(this.$stripe, 3, {
            transform: 'skewY(-4.5deg)',
            //ease: Power2.easeOut,
            delay: 3
        });
    }

    animateIn () {
        setTimeout(() => {
            $('html').removeClass("androidFix");
        }, 600);
        this.$body.removeClass('show-loading');
        this.$body.removeClass('show-preloaded');
        TweenLite.to( this.$container, .6, {
            opacity: '1',
            top: '0px',
            ease: Back.easeInOut
        });
        TweenLite.to( this.$footer, .6, {
            opacity: '1',
            transform: 'translate3d(0, 0, 0)',
            ease: Back.easeInOut
        });
        TweenLite.to( this.$stripe, .6, {
            //top: '-65px',
            transform: 'skewY(-4.5deg)',
            //delay: .3,
            ease: Back.easeInOut
        });
    }

    gtmEvent (url, title) {
        dataLayer.push({
            'event': 'VirtualPageview',
            'virtualPageURL': url,
            'virtualPageTitle' : title
        });
    }
}


// WEBPACK FOOTER //
// ./core/xhrController.js